module.exports = __webpack_public_path__ + "static/tower-bc5c2b8721a3020b70c00d74310d4e69.png";